import { useQuery } from '@tanstack/react-query';
import API_ENDPOINTS from 'services/urls';
import axiosInstance from 'ns_libs/nsAxios';
import { IUploadedProForma } from 'types/db/UploadedProForma';

interface IUploadedProFormasQueryParams {
    organizationId: string;
    dealId: number;
}

const getUploadedProFormas = async ({ organizationId, dealId }: IUploadedProFormasQueryParams): Promise<IUploadedProForma[]> => {
    const response = await axiosInstance.get(`${API_ENDPOINTS.UPLOADED_PRO_FORMAS(organizationId, dealId)}`);
    return response.data;
};

export const useGetUploadedProFormasByDeal = ({ organizationId, dealId }: IUploadedProFormasQueryParams) => useQuery({
    queryKey: ['getUploadedProFormas', dealId],
    queryFn: () => getUploadedProFormas({ organizationId, dealId }),
    staleTime: 5000,
    refetchOnMount: true,
});

export default useGetUploadedProFormasByDeal;
